<template>
  <v-toolbar flat dense>
    <v-spacer></v-spacer>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      label="Nuevo"
      iconText="mdi-plus"
      tipo="agregar"
      @click="registrarParticipante">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ParticipantesToolBar',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    registrarParticipante() {
      this.$emit('registrarParticipante');
    },
  },
};
</script>

<style lang="scss">

</style>
